import React, { useMemo } from "react";
import moment from "moment";
import { RenderKilogramo } from "../../../../../Utils/renderField/renderReadField";

export const DatosTraslado = ({
    trasladoDetalle,
    recepcionesSeleccionadas,
}) => {
    const totalKgHumedos = useMemo(() => {
        return recepcionesSeleccionadas.reduce(
            (total, recepcion) => total + (recepcion.kilos_humedos || 0),
            0,
        );
    }, [recepcionesSeleccionadas]);

    return (
        <div className="mb-3">
            {trasladoDetalle && (
                <React.Fragment>
                    <h3 className="text-center">Datos de traslado</h3>
                    <div className="formulario-fields-row">
                        <div className="formulario-field">
                            <label className="text-center">Número</label>
                            <span className="text-center">
                                {trasladoDetalle.numero}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Origen</label>
                            <span className="text-center">
                                {trasladoDetalle.acopio_origen
                                    ? trasladoDetalle.acopio_origen.nombre
                                    : ""}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Destino</label>
                            <span className="text-center">
                                {trasladoDetalle.acopio_destino
                                    ? trasladoDetalle.acopio_destino.nombre
                                    : ""}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">
                                Fecha de creación
                            </label>
                            <span className="text-center">
                                {trasladoDetalle.fecha_creacion
                                    ? moment(
                                          trasladoDetalle.fecha_creacion,
                                      ).format("DD/MM/YYYY HH:mm")
                                    : ""}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Piloto</label>
                            <span className="text-center">
                                {trasladoDetalle.piloto
                                    ? trasladoDetalle.piloto.nombre
                                    : ""}
                            </span>
                        </div>
                        <div className="formulario-field">
                            <label className="text-center">Peso Tara</label>
                            <span className="text-center">
                                <RenderKilogramo
                                    value={trasladoDetalle.peso_tara}
                                />
                            </span>
                        </div>

                        <div className="formulario-field">
                            <label className="text-center">
                                Total KG Húmedos
                            </label>
                            <span className="text-center">
                                <RenderKilogramo value={totalKgHumedos} />
                            </span>
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};
